import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 1254 1254">
    <title>Hedi Hidouri Logo</title>
    <rect width="1254" height="1254" rx="214" fill="#0C1529" />
    <polygon fill="#F1F1F1" points="355,314 474,366 474,833 355,900" />
    <polygon fill="#F1F1F1" points="474,579 629,489 629,534 474,624" />
    <polygon fill="#F1F1F1" points="474,624 744,468 744,564 474,719" />
    <polygon fill="#F1F1F1" points="629,367 744,314 744,534 629,600" />
    <polygon fill="#4A6FF0" points="516,703 744,565 744,637 588,742" />
    <polygon fill="#F1F1F1" points="516,703 627,765 627,900 516,944" />
    <polygon fill="#F1F1F1" points="516,703 627,765 627,844 516,780" />
    <polygon fill="#F1F1F1" points="627,844 797,742 797,683 627,787" />
    <polygon fill="#F1F1F1" points="795,470 895,411 895,914 795,858" />
    <polygon fill="#F1F1F1" points="795,470 895,411 895,638 795,697" />
  </svg>
);

export default IconLogo;
